if (!customElements.get('sidenav-menu')) {
  class SidenavMenu extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.target = document.querySelector(this.dataset.target);
      this.nav = this.querySelector('ul');

      if (!this.target || !this.nav) return;

      this.headers = Array.from(this.target.querySelectorAll('h2'));

      this.renderMenu();

      // Guardamos todos los links para fácil acceso
      this.links = Array.from(this.nav.querySelectorAll('a.sidenav-menu__link'));

      // Evento scroll para actualizar active según sección visible
      window.addEventListener(
        'scroll',
        () => {
          this.updateActiveOnScroll();
        },
        { passive: true }
      );

      // Evento click para activar el link clicado
      this.links.forEach((link) => {
        link.addEventListener('click', (e) => {
          this.setActiveLink(e.currentTarget);
        });
      });

      // Activar desde el inicio
      this.updateActiveOnScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateActiveOnScroll);
    }

    renderMenu() {
      let pageTitle = document.title.split('–')[0].trim();
      const titleItem = document.createElement('li');
      titleItem.className = 'sidenav-menu__title';
      titleItem.textContent = pageTitle;
      this.nav.insertBefore(titleItem, this.nav.firstChild);

      this.headers.forEach((h) => {
        h.id = h.textContent
          .trim()
          .toLowerCase()
          .replaceAll(' ', '-')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'sidenav-menu__link link';
        link.href = `#${h.id}`;
        link.textContent = h.textContent;

        item.appendChild(link);
        this.nav.appendChild(item);
      });
    }

    updateActiveOnScroll() {
      const scrollPos = window.scrollY || window.pageYOffset;
      const offset = 100;

      let currentId = null;

      for (let i = this.headers.length - 1; i >= 0; i--) {
        const headerTop = this.headers[i].getBoundingClientRect().top + window.scrollY;
        if (scrollPos + offset >= headerTop) {
          currentId = this.headers[i].id;
          break;
        }
      }

      if (!currentId) {
        this.clearActiveLinks();
        return;
      }

      const activeLink = this.links.find((link) => link.getAttribute('href') === `#${currentId}`);

      if (activeLink) {
        this.setActiveLink(activeLink);
      }
    }

    setActiveLink(link) {
      this.links.forEach((l) => l.classList.remove('active'));
      link.classList.add('active');
    }

    clearActiveLinks() {
      this.links.forEach((l) => l.classList.remove('active'));
    }
  }

  customElements.define('sidenav-menu', SidenavMenu);
}
